/**
 * Created by mauget on 1/21/16.
 */

import _ from 'lodash';
import Backbone from 'backbone';

//==================================================================
// This is a simple importable singleton that functions as a
// Backbone global event bus, taking trigger calls that
// route to registered listeners.
//
// Use this for communicating between otherwise unrelated views.
// E.g.
//
// A sending view:
//  eventBus.trigger( 'focus:nameChange', aName);
//
// One of possibly many listening views:
//  this.listenTo( eventBus, 'focus:nameChange', this.nameChange );
//
// -Lou Mauget, January, 21, 2016
//==================================================================
const eventBus = _.clone(Backbone.Events);
export default eventBus;
